import {twJoin} from 'tailwind-merge'

import {IconDocument} from '@sdox/icons'

interface BadgePartProps {
  itemCount: number
}

export const BadgePart = (props: BadgePartProps) => {
  const {
    itemCount,
  } = props
  return (
    <div
      className={twJoin(
        'z-10 absolute bottom-spacing-8 right-spacing-8',
        'pl-spacing-12 pr-spacing-8 flex items-center gap-spacing-4 text-glyph-inversed-primary h-spacing-36',
        'rounded-radius-sm backdrop-blur-1 bg-interactive-surface-overlay-default-default/40',
      )}
    >
      <span>{itemCount}</span>
      <IconDocument className={'size-spacing-20'}/>
    </div>
  )
}
